import { useState } from "react";
import "./styles/errorModal.css";

interface ModalProps {
  isOpen: boolean;
  onClose: () => void; // Add this
}

const DetailErrorRoleModal = ({ isOpen, onClose }: ModalProps) => {
  const [showDetails, setShowDetails] = useState(false);

  if (!isOpen) return null;

  return (
    <div className="modal-overlayDetail" onClick={onClose}>
      <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{position: "relative", background: "linear-gradient(to bottom, rgb(96, 64, 239), rgb(128, 86, 242))", color: "white", fontFamily: "ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji"}}>
      {/* <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{position: "relative", backgroundColor: "rgb(96, 64, 239)", color: "white", fontFamily: "ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji"}}> */}
      {/* <div className="modal-box" onClick={(e) => e.stopPropagation()} style={{position: "relative", background: "linear-gradient(#5e67fb 0%, #5e67fb 5%, #383d95 100%)", color: "white", fontFamily: "ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji"}}> */}
        {/* Close Icon/Button */}
        <button
          className="close-button"
          onClick={onClose}
          aria-label="Close modal"
          style={{color: "white"}}
        >
          &times;
        </button>

        <div
          className="details-box"
          style={{
            whiteSpace: "pre-wrap",
            padding: "1rem",
            background: "",
            borderRadius: "8px",
            textAlign: "left",
          }}
        >
          <strong style={{fontSize: "17px"}}>PEN VIP Tiers (only path to faucet access)</strong>
          <ul style={{paddingLeft: "20px", fontSize: "14px", lineHeight: "18px"}}>
            <li style={{marginBottom: "5px"}}>
              <strong>VIP1:</strong> Hold 200,000+ PEN on Pentagon Chain — receives 1% of weekly pool per claim
            </li>
            <li style={{marginBottom: "5px"}}>
              <strong>VIP2:</strong> Hold 1,000,000+ PEN on Pentagon Chain — receives 10% of weekly pool per claim <em>(best value per PEN)</em>
            </li>
            <li style={{marginBottom: "5px"}}>
              <strong>VIP3:</strong> Hold 5,000,000+ PEN on Pentagon Chain — receives 50% of weekly pool per claim
            </li>
          </ul>
          <p style={{fontSize: "14px", lineHeight: "18px", paddingLeft: "4px"}}>
            Acquire $PEN on Uniswap, Kucoin, MEXC, or XT, then bridge to Pentagon Chain.
            There are many VIP programs on Pentagon Games, but <strong>only PEN VIP grants faucet access</strong>.
          </p>

          <strong style={{fontSize: "17px"}}>How to Verify Your Roles:</strong>
          <ol style={{paddingLeft: "20px", fontSize: "14px", lineHeight: "18px"}}>
            <li style={{marginBottom: "5px"}}>Join our&nbsp;
              <a
              href="https://discord.gg/pentagongamesxp"
              style={{ textDecoration: "underline" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Pentagon Games Discord</a>
            </li>
            <li style={{marginBottom: "5px"}}>
            Click the button in the channel <strong>#verify-get-role</strong>, and your roles will be updated
            instantly!
            </li>
          </ol>
          <p style={{fontSize: "17px", fontWeight: "bold"}}>
            {/* <strong>To access the faucet, you need to have any of these roles -</strong>{"\n"}
            1. Proud BCSH Hero NFT owners. Get yours here:{" "}
            <a
              href="https://bcsh.xyz/"
              style={{ textDecoration: "underline" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              https://bcsh.xyz/
            </a>{"\n"}
            2. Hold at least 10,000 $PEN. Acquire $PEN on Uniswap, Kucoin, MEXC,
            or XT. If you acquired $PEN on a CEX, transfer it to your wallet
            connected to Pentagon Games.{"\n"}
            3. Hold an Ethan NFT, get one here:{" "}
            <a
              href="https://eth.bcsh.xyz/"
              style={{ textDecoration: "underline" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              https://eth.bcsh.xyz/
            </a>{" "}
            or at least 50k+ $PEN in your wallet associated with Pentagon
            Games.{"\n\n"} */}
            {/* <strong>How to Verify Your Roles:</strong>{"\n"}
            1. Join our{" "}
            <a
              href="https://discord.gg/pentagongamesxp"
              style={{ textDecoration: "underline" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Pentagon Games Discord
            </a>:{"\n"}
            2. Click the button in the channel{" "}
            <strong>#verify-get-role</strong>, and your roles will be updated
            instantly!{"\n\n"} */}
            Once verified, refresh the page and you'll gain access to the
            faucet.</p>
            <p style={{marginBottom: "0px", fontSize: "17px", fontWeight: "bold"}}>
            Need help? Create a support ticket on{" "}
            <a
              href="https://discord.gg/pentagongamesxp"
              style={{ textDecoration: "underline" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Discord
            </a>
            , and our CMs will assist you.
          </p>
        </div>

        <div className="box-message tooltip-container-new">
          <div></div>
          <div className="tooltip-new"></div>
        </div>
      </div>
    </div>
  );
};

export default DetailErrorRoleModal;

